import { useSelector } from 'react-redux'
import {
  selectCustomerIsLoanOfficer,
  selectHasHomebotNetworkFeatureFlag
} from '../../../../store/selectors/customerProfile'
import { selectClientTeamMemberships } from '../../../../store/selectors/clientTeamMemberships'
import { RealEstateAgentCard } from '../RealEstateAgentCard/RealEstateAgentCard'
import { UnverifiedAgentCard } from './UnverifiedAgentCard'
import { VerifiedAgentCard } from './VerifiedAgentCard'
import { Listing } from '../../../../api/gqlaxy/gql/generated/graphql'
import { selectClientFetchId, selectClientFirstHome } from '../../../../store/selectors/client'

export interface ListingMessageCardContainerProps {
  listing?: Listing
}

export const ListingMessageCardContainer = ({ listing }: ListingMessageCardContainerProps) => {
  const isCustomerOnHomebotNetwork = useSelector(selectHasHomebotNetworkFeatureFlag)
  const { data: clientTeamMemberships } = useSelector(selectClientTeamMemberships)
  const clientTeamMembership = clientTeamMemberships[0]
  const isCustomerLO = useSelector(selectCustomerIsLoanOfficer)
  const home = useSelector(selectClientFirstHome)
  const clientId = useSelector(selectClientFetchId)
  const homeStreetAddress = home?.address?.street

  if (isCustomerLO && isCustomerOnHomebotNetwork && !!clientTeamMembership) {
    if (clientTeamMembership.isVerified) {
      return <VerifiedAgentCard listing={listing} clientTeamMembership={clientTeamMembership} />
    }

    return (
      <UnverifiedAgentCard
        listing={listing}
        clientTeamMembership={clientTeamMembership}
        clientId={clientId}
        streetAddress={homeStreetAddress}
      />
    )
  }

  return <RealEstateAgentCard listing={listing} />
}
